/* eslint-disable no-useless-escape */
import { InfoRounded, Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button, CircularProgress, Container, FormHelperText, Grid, IconButton, TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import { registration } from '../../../../Redux/Models/auth';
import Elements from '../../../Elements';

const DisplayingErrorMessagesSchema = Yup.object().shape({
  // username: Yup.string()
  //   .min(3, 'Name is too short')
  //   .required('Name field is required'),
  email: Yup.string()
    .email('Please check your email address format')
    .required('Email field is required'),
  password: Yup.string()
    .required('Password field is required')
    .min(8, 'Must contain minimum 8 characters')
    .matches(
      /^(?=.*[a-z])/,
      'Must Contain One Lowercase Character',
    )
    .matches(
      /^(?=.*[A-Z])/,
      'Must Contain One Uppercase Character',
    )
    .matches(
      /^(?=.*[0-9])/,
      'Must Contain One Number Character',
    )
    .matches(
      /^(?=.*[!@#$%^&*_\-?])/,
      'Must Contain  One Special Case Character',
    ),
});

export default function SignUp({
  classes,
  isLoading,
  regisSuccess,
  error,
  message,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openAlert } = useContext(AlertContext);
  const [passTip, setPassTip] = useState(false);

  const [visible, setVisible] = useState(false);

  const formik = useFormik({
    initialValues: {
      // username: '',
      email: '',
      password: '',
    },
    validationSchema: DisplayingErrorMessagesSchema,
    onSubmit: (values) => {
      dispatch(registration(values));
    },
  });

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    if (regisSuccess && formik.touched) {
      navigate(ROUTES.signupConfirmation(), { state: formik.values });
    }
  }, [regisSuccess, formik.touched]);

  useEffect(() => {
    if (error) {
      openAlert({
        message,
        severity: 'error',
      });
    }
  }, [error, message]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            {/* <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton> */}
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">Sign up</h3>
              <div className="desc center mt-1 s-14">Please fill up your details information</div>
            </div>
            <form onSubmit={formik.handleSubmit} className="mt-6">

              {/* <div>
                <label htmlFor="name">
                  Full name
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  size="small"
                  type="text"
                  id="name"
                  placeholder="John"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    autoComplete: 'new-password',
                  }}
                  error={formik.touched.username && formik.errors.username}
                  name="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                />
                {(formik.touched.username && formik.errors.username)
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.username}
                </FormHelperText>
                )}
              </div> */}

              <div className="mt-4">
                <label htmlFor="email">
                  Email
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  size="small"
                  id="email"
                  placeholder="youremail@address.com"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    autoComplete: 'new-password',
                  }}
                  error={formik.touched.email && formik.errors.email}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {(formik.touched.email && formik.errors.email)
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.email}
                </FormHelperText>
                )}
              </div>

              <div className="mt-4">
                <label htmlFor="pass">
                  Password
                  <span className="primary-green">*</span>
                  <Elements.TooltipBase
                    icon={<InfoRounded className="mute" fontSize="small" />}
                    open={passTip}
                    onClick={() => setPassTip(true)}
                    onClose={() => setPassTip(false)}
                    message={'Must contain minimum 8 characters,\nMust Contain One Lowercase Character,\nMust Contain One Uppercase Character,\nMust Contain One Number,\nMust Contain  One Special Character'}
                  />
                </label>
                <TextField
                  size="small"
                  type={visible ? 'text' : 'password'}
                  id="pass"
                  placeholder="Password"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ m: 0, p: 0 }} onClick={toggleVisibility}>
                        {visible
                          ? <Visibility />
                          : <VisibilityOff />}
                      </IconButton>
                    ),
                    autoComplete: 'new-password',
                  }}
                  error={formik.touched.password && formik.errors.password}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {(formik.touched.password && formik.errors.password)
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.password}
                </FormHelperText>
                )}
              </div>

              <div className="mt-4">
                <Button disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} size="large" type="submit" variant="contained" className="btn-contained linear-red" fullWidth>Sign up</Button>
              </div>

              <div className="center mt-4">
                <div className="s-14 weight-600">
                  Already have an account? back to
                  {' '}
                  <Link to={ROUTES.signin()} className="link primary-green weight-700">Sign in</Link>
                </div>
              </div>
            </form>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
